import React, { Component } from 'react';
import ScrollableAnchor from 'react-scrollable-anchor';

import './Contact.css';

class Contact extends Component {

  shareWhatsapp = () => {
    window.open('https://api.whatsapp.com/send?phone=13053438780&text=Hola%2C%20quiero%20obtener%20informaci%C3%B3n');
  }

  render() {
    return (
      <ScrollableAnchor id={'contact'}>
        <section className="contact">
          <div className="common-StripeGrid">
            <div className="backgroundContainer">
              <div className="grid">
                <div className="background"></div>
              </div>
            </div>
            <div className="stripeContainer">
              <div className="grid">
                <span className="stripe s1 gray"></span>
                <span className="stripe s2 green1"></span>
                <span className="stripe s4 green2"></span>
                <span className="stripe s6 gray"></span>
                <span className="stripe s7 gray full"></span>
                <span className="stripe s11 green3"></span>
                <span className="stripe s12 green2"></span>
                <span className="stripe s13 green1"></span>
              </div>
            </div>
          </div>
          <div className="container-lg">
            <h2>
              Hablemos<br/>
            </h2>
            <div className="text">
              <p>Si tenés dudas consultas o querés cotizar un envío, <br/> mandanos un Whatsapp o escribinos en el chat.</p>
              <div className="btn-container">
                <button className="btn whatsapp-btn" onClick={this.shareWhatsapp}>
                  Envianos un Whatsapp
                </button>
                <button className="drift-open-chat btn chat-btn">
                  Escribinos en el Chat
                </button>
              </div>
            </div>
          </div>
        </section>
      </ScrollableAnchor>
    )
  }
}

export default Contact;



// WEBPACK FOOTER //
// ./src/components/Home/Contact/Contact.js